import React from 'react';
import { Icon } from '../components/Icon';
import { Link } from '../components/Link';
import { Text } from '../components/Text';

export const FirstTimersPage = ({ className, children, variant, contentKey, ...props }) => {
  return (
    <div className="font-body">
      <>
        <header className="fixed top-0 left-0 w-full z-50 bg-white/70 backdrop-blur-lg border-b border-purple-100">
          <nav className="container mx-auto px-6 py-4 flex justify-between items-center">
            <Link className="flex items-center space-x-2 group" href="index.html"><div className="w-10 h-10 bg-gradient-to-br from-primary to-accent rounded-full flex items-center justify-center shadow-lg shadow-purple-200 group-hover:rotate-12 transition-transform duration-500">
              <Icon className="w-6 h-6 text-white" viewBox="0 0 24 24" fill="none"><path d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path></Icon>
            </div>
            <Text variant="bold" className="text-2xl font-bold tracking-tight text-gray-800 font-['Quicksand']"> Zenith 
            <Text className="text-primary"> Aerial </Text></Text></Link>
            {/* Desktop Menu */}
            <div className="hidden md:flex space-x-8 items-center">
              <Link className="text-sm font-medium text-gray-600 hover:text-primary transition-colors" href="classes.html"> Classes </Link>
              <Link className="text-sm font-medium text-gray-600 hover:text-primary transition-colors" href="schedule.html"> Schedule </Link>
              <Link className="text-sm font-medium text-gray-600 hover:text-primary transition-colors" href="instructors.html"> Instructors </Link>
              <Link className="text-sm font-medium text-gray-600 hover:text-primary transition-colors" href="pricing.html"> Pricing </Link>
              <Link contentKey="cta_24" className="px-6 py-2.5 bg-primary text-white rounded-full font-bold text-sm shadow-lg shadow-purple-200 hover:bg-[#c88bc8] hover:-translate-y-0.5 transition-all duration-300" href="contact.html"> Book Now </Link>
            </div>
            {/* Mobile Toggle */}
            <button aria-expanded="false" aria-label="Toggle menu" id="mobile-menu-toggle" className="md:hidden text-gray-600">
              <Icon className="w-6 h-6" viewBox="0 0 24 24" fill="none"><path d="M4 6h16M4 12h16m-7 6h7" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path></Icon>
            </button>
            {/* Mobile Menu */}
            <div id="mobile-menu" className="hidden md:hidden absolute top-full left-0 w-full bg-white backdrop-blur-lg border-b border-purple-100 p-6 flex flex-col gap-4 z-50">
              <Link className="block py-2 text-left text-sm font-medium text-gray-600 hover:text-primary transition-colors" href="classes.html"> Classes </Link>
              <Link className="block py-2 text-left text-sm font-medium text-gray-600 hover:text-primary transition-colors" href="schedule.html"> Schedule </Link>
              <Link className="block py-2 text-left text-sm font-medium text-gray-600 hover:text-primary transition-colors" href="instructors.html"> Instructors </Link>
              <Link className="block py-2 text-left text-sm font-medium text-gray-600 hover:text-primary transition-colors" href="pricing.html"> Pricing </Link>
              <Link contentKey="cta_25" className="block py-3 px-6 text-center bg-primary text-white rounded-full font-bold text-sm shadow-lg shadow-purple-200 hover:bg-[#c88bc8] transition-all duration-300" href="contact.html"> Book Now </Link>
            </div>
          </nav>
        </header>
        <main className="pt-32 pb-24">
          {/* Your First Flight */}
          <section id="your_first_flight">
            <div className="container mx-auto px-6">
              <div className="max-w-4xl mx-auto">
                <div className="text-center mb-20">
                  <h1 className="text-5xl font-bold text-gray-900 mb-6">
                     Your First 
                    <Text className="text-primary"> Flight </Text>
                  </h1>
                  <p className="text-gray-500 text-lg">
                     Everything you need to know before you step into the hammock for the first time. 
                  </p>
                </div>
                <div className="space-y-16">
                  {/* Step 1 */}
                  <div className="flex gap-8">
                    <div className="step-number"> 1 </div>
                    <div>
                      <h3 className="text-2xl font-bold mb-4"> What to Wear </h3>
                      <p className="text-gray-500 leading-relaxed mb-4">
                         Wear form-fitting clothing that covers the backs of your knees and your underarms. This prevents the
                                            fabric from chafing your skin. Avoid loose clothing that can get tangled in the hammock. 
                      </p>
                      <div className="bg-purple-50 p-4 rounded-2xl border border-purple-100">
                        <p className="text-sm text-primary font-bold">
                           Pro Tip: Remove all jewelry, including rings and earrings, as they can snag and tear the delicate
                                                silk fabric. 
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* Step 2 */}
                  <div className="flex gap-8">
                    <div className="step-number"> 2 </div>
                    <div>
                      <h3 className="text-2xl font-bold mb-4"> Arrive Early </h3>
                      <p className="text-gray-500 leading-relaxed mb-4">
                         Please arrive at least 15 minutes before your first class. This gives us time to adjust the height of
                                            your hammock to your specific needs and introduce you to the studio. 
                      </p>
                    </div>
                  </div>
                  {/* Step 3 */}
                  <div className="flex gap-8">
                    <div className="step-number"> 3 </div>
                    <div>
                      <h3 className="text-2xl font-bold mb-4"> Listen to Your Body </h3>
                      <p className="text-gray-500 leading-relaxed mb-4">
                         Aerial yoga can be intense. If you feel dizzy or nauseous during inversions, simply come out of the
                                            pose and rest in child's pose. Our instructors are here to support you and offer modifications. 
                      </p>
                    </div>
                  </div>
                  {/* FAQ */}
                  <div className="mt-24">
                    <h2 className="text-3xl font-bold mb-12 text-center"> Frequently Asked Questions </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                      <div className="bg-slate-50 p-8 rounded-3xl">
                        <h4 className="font-bold mb-4"> Is there a weight limit? </h4>
                        <p className="text-sm text-gray-500">
                           Our hammocks and rigging are professionally installed and can support up to 1,000 lbs. We welcome
                                                students of all shapes and sizes! 
                        </p>
                      </div>
                      <div className="bg-slate-50 p-8 rounded-3xl">
                        <h4 className="font-bold mb-4"> What if I'm afraid of heights? </h4>
                        <p className="text-sm text-gray-500">
                           Most of our beginner poses are done with your feet touching the ground or just a few inches above
                                                it. You are always in control. 
                        </p>
                      </div>
                      <div className="bg-slate-50 p-8 rounded-3xl">
                        <h4 className="font-bold mb-4"> Do I need to be flexible? </h4>
                        <p className="text-sm text-gray-500">
                           Not at all! In fact, aerial yoga is one of the best ways to improve your flexibility safely and
                                                effectively. 
                        </p>
                      </div>
                      <div className="bg-slate-50 p-8 rounded-3xl">
                        <h4 className="font-bold mb-4"> Can I eat before class? </h4>
                        <p className="text-sm text-gray-500">
                           We recommend avoiding heavy meals at least 2 hours before class, as inversions on a full stomach can
                                                be uncomfortable. 
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
        <footer className="bg-slate-50 pt-24 pb-12 border-t border-purple-50">
          <div className="container mx-auto px-6">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
              <div className="col-span-1 md:col-span-2">
                <Link className="flex items-center space-x-2 mb-6" href="index.html"><div className="w-8 h-8 bg-gradient-to-br from-primary to-accent rounded-full flex items-center justify-center">
                  <Icon className="w-5 h-5 text-white" viewBox="0 0 24 24" fill="none"><path d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path></Icon>
                </div>
                <Text variant="bold" className="text-xl font-bold tracking-tight text-gray-800 font-['Quicksand']"> Zenith 
                <Text className="text-primary"> Aerial </Text></Text></Link>
                <p className="text-gray-500 max-w-sm leading-relaxed mb-8">
                   Elevate your practice and find your flow in the air. Zenith Aerial Yoga offers a sanctuary for movement,
                                mindfulness, and community. 
                </p>
                <div className="flex space-x-4">
                  <Link className="w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-sm hover:shadow-md hover:-translate-y-1 transition-all text-gray-400 hover:text-primary" href="#"><Icon className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"></path></Icon></Link>
                  <Link className="w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-sm hover:shadow-md hover:-translate-y-1 transition-all text-gray-400 hover:text-primary" href="#"><Icon className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"></path></Icon></Link>
                </div>
              </div>
              <div>
                <h4 className="text-gray-800 font-bold uppercase tracking-widest text-xs mb-6 font-['Quicksand']"> Explore </h4>
                <ul className="space-y-4 text-gray-500 text-sm">
                  <li>
                    <Link className="hover:text-primary transition-colors" href="classes.html"> Class Types </Link>
                  </li>
                  <li>
                    <Link className="hover:text-primary transition-colors" href="schedule.html"> Weekly Schedule </Link>
                  </li>
                  <li>
                    <Link className="hover:text-primary transition-colors" href="instructors.html"> Our Instructors </Link>
                  </li>
                  <li>
                    <Link className="hover:text-primary transition-colors" href="studio.html"> Studio Tour </Link>
                  </li>
                </ul>
              </div>
              <div>
                <h4 className="text-gray-800 font-bold uppercase tracking-widest text-xs mb-6 font-['Quicksand']"> Support </h4>
                <ul className="space-y-4 text-gray-500 text-sm">
                  <li>
                    <Link className="hover:text-primary transition-colors" href="first-timers.html"> First-Timer Guide </Link>
                  </li>
                  <li>
                    <Link className="hover:text-primary transition-colors" href="pricing.html"> Pricing & Packs </Link>
                  </li>
                  <li>
                    <Link className="hover:text-primary transition-colors" href="privacy.html"> Privacy Policy </Link>
                  </li>
                  <li>
                    <Link className="hover:text-primary transition-colors" href="terms.html"> Terms of Service </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="border-t border-purple-100 pt-12 flex flex-col md:flex-row justify-between items-center gap-6">
              <p className="text-xs text-gray-400"> © 2024 Zenith Aerial Yoga. All rights reserved. </p>
              <p className="text-xs text-gray-400 flex items-center">
                 Made with 
                <Icon className="w-3 h-3 mx-1 text-red-400" viewBox="0 0 20 20" fill="currentColor"><path clipRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" fillRule="evenodd"></path></Icon>
                 for the aerial community. 
              </p>
            </div>
          </div>
        </footer>
      </>
    </div>
  );
};

